import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { TypeDestination } from 'shell/models/type-destination';

export interface transformTypeDestinationResponse {
  id?: string | number;
  code?: string;
  description?: string;
  queueName?: string;
}

export const transformTypeDestination = (
  response: AxiosResponse<HttpResponse<TypeDestination>>
): transformTypeDestinationResponse => {
  const data: TypeDestination = response.data.payload || {};
  const res: transformTypeDestinationResponse = {
    id: data?.codice || '',
    code: data?.codice.toString() || '',
    description: data?.descrizione || '',
    queueName: data?.nomeCoda || '',
  };
  return res;
};
